<template>
    <div id="cerfagaz">
        <nav class="printableNo">
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">{{Name}}</span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outermargin printableNo">
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
        </div>
        <div class="pdfcontainer">
            <div v-if="numPages === 1">
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <div v-else>
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <!-- commanditaire -->
            <input class="nameOverPdf fix-focus" v-model="cerfa.customerAddress.lastName" />
            <input class="customerFirstname fix-focus" v-model="cerfa.customerAddress.firstName" />
            <textarea class="customerStreetName fix-focus" rows="4" v-model="cerfa.customerAddress.streetName" />
            <!-- enterprise -->
            <input class="companyName fix-focus" v-model="cerfa.company.company" />
            <input class="companyPhone fix-focus" v-model="cerfa.company.phoneNumber" />
            <textarea class="companyAdress fix-focus" rows="4" v-model="cerfa.company.streetName" />
            <!-- water heater info -->
            <input class="waterHeaterBrand fix-focus" v-model="cerfa.waterHeater.brand" />
            <input class="waterHeaterPower fix-focus" v-model="cerfa.waterHeater.power" />
            <input class="waterHeaterEvacuationType fix-focus" v-model="cerfa.waterHeater.evacuationType" />
            <input class="waterHeaterPutIntoUse fix-focus" v-model="cerfa.waterHeater.putIntoUse" />
            <input class="waterHeaterSerialNumber fix-focus" v-model="cerfa.waterHeater.serialNumber" />
            <!-- burner info   -->
            <input class="burnerBrand fix-focus" v-model="cerfa.burner.brand" />
            <input class="burnerPower fix-focus" v-model="cerfa.burner.power" />
            <!-- <input class="burnerEvacuationType fix-focus" v-model="cerfa.burner.evacuationType" /> -->
            <input class="burnerPutIntoUse fix-focus" v-model="cerfa.burner.putIntoUse" />
            <input class="burnerSerialNumber fix-focus" v-model="cerfa.burner.serialNumber" />
            <input class="lastIntervention fix-focus date-picker" type="date" v-model="cerfa.lastIntervention" />
            <input class="lastCleaningIntervention fix-focus date-picker" type="date" v-model="cerfa.lastCleaningIntervention" />
            <!-- mandatory checks -->
            <div class="accept deviceConnectionOk">
                <input class="fix-focus" type="checkbox" id="deviceConnectionOk" value="Validé" v-model="cerfa.deviceConnection" />
                <label for="deviceConnectionOk"></label>
            </div>
            <div class="accept deviceConnectionNOT">
                <input class="fix-focus" type="checkbox" id="deviceConnectionNOT" value="Non Validé" v-model="cerfa.deviceConnection" />
                <label for="deviceConnectionNOT"></label>
            </div>
            <!-- 2 -->
            <div class="accept burnerCorsCleaningOK">
                <input class="fix-focus" type="checkbox" id="burnerCorsCleaningOK" value="Validé" v-model="cerfa.burnerCorsCleaning" />
                <label for="burnerCorsCleaningOK"></label>
            </div>
            <div class="accept burnerCorsCleaningNOT">
                <input class="fix-focus" type="checkbox" id="burnerCorsCleaningNOT" value="Non Validé" v-model="cerfa.burnerCorsCleaning" />
                <label for="burnerCorsCleaningNOT"></label>
            </div>
            <!-- 3 -->
            <div class="accept burnerCleaningOk">
                <input class="fix-focus" type="checkbox" id="burnerCleaningOk" value="Validé" v-model="cerfa.burnerCleaning" />
                <label for="burnerCleaningOk"></label>
            </div>
            <div class="accept burnerCleaningNOT">
                <input class="fix-focus" type="checkbox" id="burnerCleaningNOT" value="Non Validé" v-model="cerfa.burnerCleaning" />
                <label for="burnerCleaningNOT"></label>
            </div>
            <!-- 4 -->
            <div class="accept deviceSecurityCheckOk">
                <input class="fix-focus" type="checkbox" id="deviceSecurityCheckOk" value="Validé" v-model="cerfa.deviceSecurityCheck" />
                <label for="deviceSecurityCheckOk"></label>
            </div>
            <div class="accept deviceSecurityCheckNOT">
                <input class="fix-focus" type="checkbox" id="deviceSecurityCheckNOT" value="Non Validé" v-model="cerfa.deviceSecurityCheck" />
                <label for="deviceSecurityCheckNOT"></label>
            </div>

            <!-- 5 -->
            <div class="accept gasEmissionCheckOk">
                <input class="fix-focus" type="checkbox" id="gasEmissionCheckOk" value="Validé" v-model="cerfa.gasEmissionCheck" />
                <label for="gasEmissionCheckOk"></label>
            </div>
            <div class="accept gasEmissionCheckNOT">
                <input class="fix-focus" type="checkbox" id="gasEmissionCheckNOT" value="Non Validé" v-model="cerfa.gasEmissionCheck" />
                <label for="gasEmissionCheckNOT"></label>
            </div>
            <!-- 6 -->
            <div class="accept devicHeatingCirculatorCheckOk">
                <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckOk" value="Validé" v-model="cerfa.devicHeatingCirculatorCheck" />
                <label for="devicHeatingCirculatorCheckOk"></label>
            </div>
            <div class="accept devicHeatingCirculatorCheckNOT">
                <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckNOT" value="Non Validé" v-model="cerfa.devicHeatingCirculatorCheck" />
                <label for="devicHeatingCirculatorCheckNOT"></label>
            </div>
            <div class="accept devicHeatingCirculatorCheckOther">
                <input class="fix-focus" type="checkbox" id="devicHeatingCirculatorCheckOther" value="Sans objet" v-model="cerfa.devicHeatingCirculatorCheck" />
                <label for="devicHeatingCirculatorCheckOther"></label>
            </div>
            <!-- 7 -->
            <div class="accept deviceRegilationComponentsCheckOk">
                <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckOk" value="Validé" v-model="cerfa.deviceRegilationComponentsCheck" />
                <label for="deviceRegilationComponentsCheckOk"></label>
            </div>
            <div class="accept deviceRegilationComponentsCheckNOT">
                <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckNOT" value="Non Validé" v-model="cerfa.deviceRegilationComponentsCheck" />
                <label for="deviceRegilationComponentsCheckNOT"></label>
            </div>
            <div class="accept deviceRegilationComponentsCheckOther">
                <input class="fix-focus" type="checkbox" id="deviceRegilationComponentsCheckOther" value="Sans objet" v-model="cerfa.deviceRegilationComponentsCheck" />
                <label for="deviceRegilationComponentsCheckOther"></label>
            </div>
            <!-- 8 -->
            <div class="accept gasVMCOk">
                <input class="fix-focus" type="checkbox" id="gasVMCOk" value="Validé" v-model="cerfa.gasVMC" />
                <label for="gasVMCOk"></label>
            </div>
            <div class="accept gasVMCNOT">
                <input class="fix-focus" type="checkbox" id="gasVMCNOT" value="Non Validé" v-model="cerfa.gasVMC" />
                <label for="gasVMCNOT"></label>
            </div>
            <div class="accept gasVMCOther">
                <input class="fix-focus" type="checkbox" id="gasVMCOther" value="Sans objet" v-model="cerfa.gasVMC" />
                <label for="gasVMCOther"></label>
            </div>
            <!-- 9 -->
            <div class="accept antiSmokeCheckOk">
                <input class="fix-focus" type="checkbox" id="antiSmokeCheckOk" value="Validé" v-model="cerfa.antiSmokeCheck" />
                <label for="antiSmokeCheckOk"></label>
            </div>
            <div class="accept antiSmokeCheckNOT">
                <input class="fix-focus" type="checkbox" id="antiSmokeCheckNOT" value="Non Validé" v-model="cerfa.antiSmokeCheck" />
                <label for="antiSmokeCheckNOT"></label>
            </div>
            <div class="accept antiSmokeCheckOther">
                <input class="fix-focus" type="checkbox" id="antiSmokeCheckOther" value="Sans objet" v-model="cerfa.antiSmokeCheck" />
                <label for="antiSmokeCheckOther"></label>
            </div>
            <!-- 10 -->
            <div class="accept deviceAnodeAndAccessoriesCheckOk">
                <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckOk" value="Validé" v-model="cerfa.deviceAnodeAndAccessoriesCheck" />
                <label for="deviceAnodeAndAccessoriesCheckOk"></label>
            </div>
            <div class="accept deviceAnodeAndAccessoriesCheckNOT">
                <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckNOT" value="Non Validé" v-model="cerfa.deviceAnodeAndAccessoriesCheck" />
                <label for="deviceAnodeAndAccessoriesCheckNOT"></label>
            </div>
            <div class="accept deviceAnodeAndAccessoriesCheckOther">
                <input class="fix-focus" type="checkbox" id="deviceAnodeAndAccessoriesCheckOther" value="Sans objet" v-model="cerfa.deviceAnodeAndAccessoriesCheck" />
                <label for="deviceAnodeAndAccessoriesCheckOther"></label>
            </div>
            <!-- sad -->
            <div class="accept deviceHydrauliquePressureCheckOk">
                <input class="fix-focus" type="checkbox" id="deviceHydrauliquePressureCheckOk" value="Non Validé" v-model="cerfa.deviceHydrauliquePressureCheck" />
                <label for="deviceHydrauliquePressureCheckOk"></label>
            </div>
            <div class="accept deviceHydrauliquePressureCheckNOT">
                <input class="fix-focus" type="checkbox" id="deviceHydrauliquePressureCheckNOT" value="Sans objet" v-model="cerfa.deviceHydrauliquePressureCheck" />
                <label for="deviceHydrauliquePressureCheckNOT"></label>
            </div>

            <textarea class="otherCheckedPoints fix-focus" rows="2" v-model="cerfa.otherCheckedPoints" />
            <!-- added tests -->
            <input class="smokeTemperature fix-focus" v-model="cerfa.deviceMesures.smokeTemperature" />
            <input class="ambianteTemperature fix-focus" v-model="cerfa.deviceMesures.ambianteTemperature" />
            <input class="smokeContent fix-focus" v-model="cerfa.deviceMesures.smokeContent" />
            <!-- teneur en CO -->
            <input class="contentCO fix-focus" v-model="cerfa.deviceMesures.contentCO" />

            <div class="accept contentCOPercentageOk">
                <input class="fix-focus" type="checkbox" id="contentCOPercentageOk" value="Validé" v-model="cerfa.contentCOPercentage" />
                <label for="contentCOPercentageOk"></label>
            </div>
            <div class="accept contentCOPercentageNOT">
                <input class="fix-focus" type="checkbox" id="contentCOPercentageNOT" value="Non Validé" v-model="cerfa.contentCOPercentage" />
                <label for="contentCOPercentageNOT"></label>
            </div>
            <div class="accept contentCOPercentageDanger">
                <input class="fix-focus" type="checkbox" id="contentCOPercentageDanger" value="Sans objet" v-model="cerfa.contentCOPercentage" />
                <label for="contentCOPercentageDanger"></label>
            </div>
            <!--  -->
            <input class="mesurementDevice fix-focus" v-model="cerfa.mesurementDevice" />
            <!-- performance -->
            <input class="mesuredPerformance fix-focus" v-model="cerfa.heaterPerformance.mesuredPerformance" />
            <input class="referencedPerformance fix-focus" v-model="cerfa.heaterPerformance.referencedPerformance" />
            <input class="NOxEmission fix-focus" v-model="cerfa.heaterPerformance.NOxEmission" />
            <!-- remarks -->
            <textarea class="correctedDefect fix-focus" rows="6" v-model="cerfa.correctedDefect" />
            <textarea class="usageRecommendation fix-focus" rows="9" v-model="cerfa.usageRecommendation" />
            <textarea class="upgradeRecommendation fix-focus" rows="9" v-model="cerfa.upgradeRecommendation" />
            <textarea class="futureRecommendation fix-focus" rows="7" v-model="cerfa.futureRecommendation" />
            <input class="signatureTimestamp fix-focus date-picker" type="date" v-model="cerfa.signatureTimestamp" />
            <img :src="sig" class="imgOverPdf" />
            <img :src="sig2" class="imgOverPdf2" />
        </div>
        <div class="outercircle printableNo">
            <span class="sigBot">Signature Technicien :</span>
            <VueSignaturePad width="400px" height="150px" :class="sigpadclass" ref="signaturePad" />
            <span class="sigBot">Signature Client :</span>
            <VueSignaturePad width="400px" height="150px" :class="sigpadclass" ref="signaturePad2" />
            <button class="docBtn" :title="title" type="button" :disabled="validated" v-on:click="validatePDF()">Valider et enregistrer le Cerfa</button>
            <button class="docBtn2" :title="title2" type="button" :disabled="!validated" v-on:click="print()">Télécharger le Cerfa en PDF</button>
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf';
import axios from 'axios';

export default {
    name: 'Cerfagaz',
    components: {
        pdf
    },
    data() {
        return {
            Name: "client",
            cerfa: {
                customerAddress: {
                    streetNb: "",
                    streetName: "",
                    postalCode: "",
                    city: "",
                    firstName: "",
                    lastName: "Test",
                    phoneNumber: "",
                    company: "",
                    emailAddress: ""
                },
                waterHeater: {
                    brand: "",
                    power: "",
                    evacuationType: "",
                    putIntoUse: "",
                    serialNumber: "",
                },
                burner: {
                    brand: "",
                    power: "",
                    evacuationType: "",
                    putIntoUse: "",
                    serialNumber: "",
                },
                deviceConnection: [],
                burnerCorsCleaning: [],
                burnerCleaning: [],
                deviceSecurityCheck: [],
                gasEmissionCheck: [],
                devicHeatingCirculatorCheck: [],
                deviceRegilationComponentsCheck: [],
                gasVMC: [],
                antiSmokeCheck: [],
                deviceAnodeAndAccessoriesCheck: [],
                deviceHydrauliquePressureCheck: [],
                otherCheckedPoints: '',
                deviceMesures: {
                    smokeTemperature: '',
                    ambianteTemperature: '',
                    smokeContent: '',
                },
                contentCO: '',
                contentCOPercentage: [],
                mesurementDevice: '',
                heaterPerformance: {
                    mesuredPerformance: '',
                    referencedPerformance: '',
                    NOxEmission: '',
                },
                correctedDefect: '',
                usageRecommendation: '',
                upgradeRecommendation: '',
                futureRecommendation: '',
                lastIntervention: '',
                lastCleaningIntervention: '',
                company: {
                    streetNb: "",
                    streetName: "",
                    postalCode: "",
                    city: "",
                    firstName: "",
                    lastName: "",
                    phoneNumber: "",
                    company: "",
                    emailAddress: ""
                },
                signatureTimestamp: "",
                signatureCity: "",
                status: "à remplir"
            },
            inquiry: {},
            pdfLink: "/assets/gaz.pdf",
            sig: "/assets/nosignature.png",
            sig2: "/assets/nosignature.png",
            numPages: 2,
            validated: false,
            navWidth: 0,
            navMenuVisible: false,
            sigpadclass: "signature",
            files: [],
            title: "Valider le Cerfa",
            title2: "Veuillez valider le Cerfa afin de l'enregistrer"
        };
    },
    methods: {
        reload() {
            this.$cookie.set('currentAriane', "");
            this.$cookie.set('history', "");
            this.$cookie.set('historyQuery', "");
            this.$router.replace({ name: "techhome" });
        },
        validatePDF2() {
            const { isEmpty, data } = this.$refs.signaturePad2.saveSignature();
            if (isEmpty) {
                alert("Vous devez signer le document pour le valider");
            }
            else {
                this.sig2 = data;
                this.putGAZsheet();
            }
        },
        validatePDF() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if (isEmpty) {
                alert("Vous devez signer le document pour le valider");
            }
            else {
                this.sig = data;
                this.validatePDF2();
            }
        },
        print() {
            window.print();
        },
        logout() {
            this.$cookie.delete('jwt');
            this.$cookie.delete('role');
            this.$cookie.delete('firstName');
            this.$cookie.delete('lastName');
            this.$cookie.delete('currentAriane');
            this.$cookie.delete('history');
            this.$cookie.delete('historyQuery');
            this.$router.replace({ name: "login" });
        },
        backbtn() {

            var strHist = this.$cookie.get('history');
            var arrHist = JSON.parse(strHist);
            var strQuery = this.$cookie.get('historyQuery');
            var arrQuery = JSON.parse(strQuery);

            this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
            this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

            if (arrHist.length) {
                if (arrQuery[arrQuery.length - 1] !== "" && arrQuery[arrQuery.length - 1] !== "undefined") {
                    this.$router.replace({ name: arrHist[arrHist.length - 1], query: { name: arrQuery[arrQuery.length - 1] } });
                }
                else {
                    this.$router.replace({ name: arrHist[arrHist.length - 1] });
                }
            }
            else {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "techhome" });
            }
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        async putSignature2(idCerfa) {
            var file = this.dataURLtoFile(this.sig2, 'picture.png');
            const fd = new FormData();
            fd.append('picture', file, "picture.png");

            var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/gaz/customer/' + this.inquiry.name + '/' + idCerfa, fd)
            console.log(response);
            if (response) {
                this.validated = true;
                this.title = "Cerfa dejà validé";
                this.title2 = "Enregistrer le Cerfa";
                this.sigpadclass = "signaturedisable";
                this.$refs.signaturePad2.lockSignaturePad()
                console.log("cerfa validé !");
            }
        },
        async putSignature(idCerfa) {
            var file = this.dataURLtoFile(this.sig, 'picture.png');
            const fd = new FormData();
            fd.append('picture', file, "picture.png");

            var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/gaz/tech/' + this.inquiry.name + '/' + idCerfa, fd)
            console.log(response);
            if (response) {
                this.validated = true;
                this.title = "Cerfa dejà validé";
                this.title2 = "Enregistrer le Cerfa";
                this.sigpadclass = "signaturedisable";
                this.$refs.signaturePad.lockSignaturePad()
                console.log("cerfa validé !");
                this.putSignature2(idCerfa);
            }
        },
        async putGAZsheet() {
            delete this.cerfa._id;
            var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/gaz/' + this.inquiry.name, { cerfa: this.cerfa })
            console.log(response);
            if (response) {
                this.putSignature(response.data.id);
            }
        },
        async getInquiries(){
            var nameInq = this.$route.query.name.split('/').join('%2F');
            var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq)
            if(response.data.inquiry){
                this.inquiry = response.data.inquiry;
                if (this.inquiry.fioulsheet) {
                    this.getCerfa(this.inquiry.fioulsheet._id);
                }
            }
        },
        async getInquiry(id) {
            axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
            var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/fromintervention/' + id);
            if (response.data.inquiry) {
                this.inquiry = response.data.inquiry;
                if (this.inquiry.gazsheet) {
                    this.getCerfa(this.inquiry.gazsheet._id);
                }
            }
        },
        async getCerfa(id) {
            var response = await axios.get('https://so.gaviota.fr/api/building/gaz/' + id)
            if (response.data.cerfa) {
                this.cerfa = response.data.cerfa;
                if (this.cerfa) {
                    if (this.cerfa.status === "signé" && this.cerfa.signatureTech) {
                        this.validated = true;
                        this.title = "Cerfa dejà validé";
                        this.title2 = "Enregistrer le cerfa";
                        this.sigpadclass = "signaturedisable";

                        this.sig = 'data:' + this.cerfa.signatureTech.img.contentType + ';base64,' + btoa(
                            new Uint8Array(this.cerfa.signatureTech.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                        this.sig2 = 'data:' + this.cerfa.signatureCustomer.img.contentType + ';base64,' + btoa(
                            new Uint8Array(this.cerfa.signatureCustomer.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                        this.$refs.signaturePad.fromDataURL(this.sig)
                        this.$refs.signaturePad.lockSignaturePad()

                        this.$refs.signaturePad2.fromDataURL(this.sig2)
                        this.$refs.signaturePad2.lockSignaturePad()
                    }
                    if(this.$cookie.get('role') === "admin" && this.$cookie.get('reloaded') === "false"){
                        this.$cookie.set('reloaded', "true");
                        location.reload();
                    }
                }
            }
        },
        getCookies: function () {
            if (!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') === "client" || !this.$route.query.name) {
                this.logout();
            }
            else {
                this.Name = this.$cookie.get('firstName') + " " + this.$cookie.get('lastName');

                if(this.$cookie.get('role') !== "admin"){
                    this.getInquiry(this.$route.query.name);
                }
                else{
                    this.getInquiries();
                }
            }
        },
    },
    mounted() {
        this.getCookies();
    }
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=BenchNine");

#cerfagaz {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    background-color: #f0f0f0;
    margin: auto;
    border: none;
}
h1 {
    background-color: #1ce83e;
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    padding-bottom: 15px;
    padding-top: 15px;
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    display: block;
    text-align: center;
    position: relative;
}
h2 {
    border-bottom: 2px solid;
    border-color: #1ce83e;
    color: black;
}
nav {
    top: 0px;
    left: 0px;
    right: 0px;
    margin: 0px;
    position: fixed;
    z-index: 11;
    width: 100%;
    background-color: white;
    border-bottom: 2px solid;
    border-color: #1ce83e;
}
.main {
    display: inline-block;
    cursor: pointer;
    margin: 5px;
}
.rightNav {
    position: absolute;
    top: 0;
    right: 0;
}
.innerNav {
    display: inline-block;
    position: relative;
}
.logoNav {
    vertical-align: middle;
    margin: 5px;
}
.navLogout {
    height: 20px;
    vertical-align: middle;
    cursor: pointer;
    margin: 24px;
}
.leftNav {
    position: absolute;
    top: 0;
    left: 0;
}
.pNav {
    display: inline-block;
    padding-right: 15px;
    font-family: "BenchNine", sans-serif;
    font-size: 20px;
    vertical-align: middle;
}
@media screen and (max-width: 768px) {
    .pNav {
        display: none;
    }
}
.homeName {
    margin: auto;
    font-family: "BenchNine", sans-serif;
    font-size: 20px;
    text-align: center;
    margin: 10px;
}
#circle {
    width: 10px;
    height: 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background: #1ce83e;
    margin: auto;
}
.outermargin {
    background-color: #f0f0f0;
    padding: 15px;
}
.btnBack {
    border: none;
    cursor: pointer;
    display: inline-block;
    font-size: 30px;
    margin-top: 80px;
    margin-left: 50px;
    background-color: #f0f0f0;
}
.pdfcontainer {
    width: 800px;
    margin: auto;
    position: relative;
    .fix-focus:focus {
        outline: none;
    }
    .date-picker::-webkit-calendar-picker-indicator {
        opacity: 1;
    }
    .date-picker::-webkit-clear-button,
    .date-picker::-webkit-inner-spin-button {
        display: none;
        -webkit-appearance: none;
    }
    .nameOverPdf {
        position: absolute;
        top: 73px;
        left: 180px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .customerFirstname {
        position: absolute;
        top: 108px;
        right: 440px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .customerStreetName {
        position: absolute;
        top: 140px;
        left: 206px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .companyName {
        position: absolute;
        top: 74px;
        right: 20px;
        width: 180px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .companyPhone {
        position: absolute;
        top: 126px;
        right: 217px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .companyAdress {
        position: absolute;
        top: 142px;
        right: 32px;
        width: 300px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .waterHeaterBrand {
        position: absolute;
        top: 230px;
        left: 150px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterPower {
        position: absolute;
        top: 249px;
        left: 225px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterEvacuationType {
        position: absolute;
        top: 266px;
        left: 170px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterPutIntoUse {
        position: absolute;
        top: 282px;
        left: 168px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .waterHeaterSerialNumber {
        position: absolute;
        top: 300px;
        left: 128px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerBrand {
        position: absolute;
        top: 248px;
        right: 73px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerPower {
        position: absolute;
        top: 265px;
        right: 24px;
        width: 100px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerEvacuationType {
        position: absolute;
        top: 248px;
        right: 84px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerPutIntoUse {
        position: absolute;
        top: 281px;
        right: 28px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .burnerSerialNumber {
        position: absolute;
        top: 300px;
        right: 70px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .lastIntervention {
        position: absolute;
        top: 322px;
        left: 240px;
        width: 106px;
        font-size: 14px;
        background-color: white;
        border: 0px solid;
    }
    .lastCleaningIntervention {
        position: absolute;
        top: 322px;
        right: 60px;
        width: 106px;
        font-size: 14px;
        background-color: white;
        border: 0px solid;
    }
    .deviceConnectionOk {
        position: absolute;
        top: 387px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceConnectionNOT {
        position: absolute;
        top: 387px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .burnerCorsCleaningOK {
        position: absolute;
        top: 421px;
        right: 119px;
        font-size: 14px;
        background-color: transparent;
    }
    .burnerCorsCleaningNOT {
        position: absolute;
        top: 421px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }

    .burnerCleaningOk {
        position: absolute;
        top: 446px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .burnerCleaningNOT {
        position: absolute;
        top: 446px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceSecurityCheckOk {
        position: absolute;
        top: 462px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceSecurityCheckNOT {
        position: absolute;
        top: 463px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .preFilterFioulCleaningOther {
        position: absolute;
        top: 463px;
        right: 192px;
        font-size: 14px;
        background-color: transparent;
    }
    .gasEmissionCheckOk {
        position: absolute;
        top: 481px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .gasEmissionCheckNOT {
        position: absolute;
        top: 481px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }

    .devicHeatingCirculatorCheckOk {
        position: absolute;
        top: 500px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .devicHeatingCirculatorCheckNOT {
        position: absolute;
        top: 500px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceRegilationComponentsCheckOk {
        position: absolute;
        top: 517px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceRegilationComponentsCheckNOT {
        position: absolute;
        top: 517px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .devicHeatingCirculatorCheckOther {
        position: absolute;
        top: 499px;
        right: 192px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceRegilationComponentsCheckOther {
        position: absolute;
        top: 517px;
        right: 192px;
        font-size: 14px;
        background-color: transparent;
    }
    .gasVMCOk {
        position: absolute;
        top: 541px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .gasVMCNOT {
        position: absolute;
        top: 541px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .gasVMCOther {
        position: absolute;
        top: 541px;
        right: 192px;
        font-size: 14px;
        background-color: transparent;
    }
    .antiSmokeCheckOk {
        position: absolute;
        top: 569px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .antiSmokeCheckNOT {
        position: absolute;
        top: 569px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .antiSmokeCheckOther {
        position: absolute;
        top: 569px;
        right: 192px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceAnodeAndAccessoriesCheckOk {
        position: absolute;
        top: 592px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceAnodeAndAccessoriesCheckNOT {
        position: absolute;
        top: 592px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceAnodeAndAccessoriesCheckOther {
        position: absolute;
        top: 592px;
        right: 192px;
        font-size: 14px;
        background-color: transparent;
    }

    .deviceHydrauliquePressureCheckOk {
        position: absolute;
        top: 642px;
        right: 118px;
        font-size: 14px;
        background-color: transparent;
    }
    .deviceHydrauliquePressureCheckNOT {
        position: absolute;
        top: 642px;
        right: 55px;
        font-size: 14px;
        background-color: transparent;
    }

    .otherCheckedPoints {
        position: absolute;
        top: 662px;
        left: 145px;
        width: 600px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }

    .smokeTemperature {
        position: absolute;
        top: 741px;
        left: 197px;
        width: 40px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .ambianteTemperature {
        position: absolute;
        top: 742px;
        right: 219px;
        width: 40px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .smokeContent {
        position: absolute;
        top: 759px;
        right: 295px;
        width: 100px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }

    .contentCO {
        position: absolute;
        top: 782px;
        right: 134px;
        width: 50px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .contentCOPercentageOk {
        position: absolute;
        top: 811px;
        left: 64px;

        font-size: 14px;
        background-color: transparent;
    }
    .contentCOPercentageNOT {
        position: absolute;
        top: 846px;
        left: 64px;

        font-size: 14px;
        background-color: transparent;
    }
    .contentCOPercentageDanger {
        position: absolute;
        top: 886px;
        left: 64px;

        font-size: 14px;
        background-color: transparent;
    }
    .mesurementDevice {
        position: absolute;
        top: 949px;
        left: 45px;
        width: 700px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .mesuredPerformance {
        position: absolute;
        top: 1021px;
        left: 305px;
        width: 25px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .referencedPerformance {
        position: absolute;
        top: 1061px;
        left: 305px;
        width: 25px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .NOxEmission {
        position: absolute;
        top: 1021px;
        right: 45px;
        width: 40px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .correctedDefect {
        position: absolute;
        top: 1380px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .usageRecommendation {
        position: absolute;
        top: 1530px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .upgradeRecommendation {
        position: absolute;
        top: 1710px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .futureRecommendation {
        position: absolute;
        top: 1900px;
        left: 33px;
        width: 725px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
        resize: none;
        overflow: hidden;
    }
    .signatureTimestamp {
        position: absolute;
        top: 2100px;
        left: 387px;
        width: 150px;
        font-size: 14px;
        background-color: white;
        border: 0px solid;
    }
    .imgOverPdf2 {
        position: absolute;
        bottom: 80px;
        left: 200px;
        width: 128px;
        height: 48px;
    }
    .accept {
        margin-bottom: 20px;
        input[type="checkbox"] {
            display: none;
        }
        input[type="checkbox"] + label {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 20px;
            font-size: 0.9rem;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
        }
        input[type="checkbox"] + label:last-child {
            margin-bottom: 0;
        }
        input[type="checkbox"] + label:before {
            content: "";
            display: block;
            width: 8px;
            height: 8px;
            border: 2px solid black;
            position: absolute;
            left: 6px;
            top: 6px;
            -webkit-transition: all 0.12s, border-color 0.08s;
            transition: all 0.12s, border-color 0.08s;
        }
        input[type="checkbox"]:checked + label:before {
            width: 10px;
            top: 0px;
            left: 5px;
            border-radius: 0;
            border: 2px solid black;

            opacity: 1;
            border-top-color: transparent;
            border-left-color: transparent;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
        }
    }
}
.pdfViewer {
    width: 100%;
}
.imgOverPdf {
    position: absolute;
    bottom: 82px;
    right: 97px;
    width: 128px;
    height: 48px;
}

.outercircle {
    background-color: #f0f0f0;
    padding: 50px;
    width: 800px;
    margin: auto;
    position: relative;
}
.docBtn {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-right: 100px;
    width: 200px;
    position: absolute;
    top: 107px;
    right: 0px;
}
.docBtn2 {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-right: 100px;
    width: 200px;
    position: absolute;
    top: 166px;
    right: 0px;
}
.docBtn3 {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-left: 100px;
    width: 200px;
    position: absolute;
    top: 30px;
    left: 250px;
}
button:disabled,
button[disabled] {
    border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
    cursor: no-drop;
}
@media print {
    .printableNo {
        display: none;
    }
}
@page {
    size: auto;
    margin: 0mm;
}
.sideNav {
    background-clip: border-box;
    background-color: #fff;
    background-origin: padding-box;
    box-sizing: border-box;
    background-color: #333;
    display: block;
    height: 100%;
    overflow: auto;
    box-shadow: 8px 0px 6px -6px #999;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
}
.navsidecontent {
    color: white;
    font-family: "BenchNine", sans-serif;
    margin-top: 65px;
    margin-left: 30px;
    margin-right: 30px;
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
}
.navtitle {
    margin: 10px;
    margin-top: 15px;
    padding-top: 5px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    border-top: 1px solid;
    border-color: #eee;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: default;
}
.navsubtitle {
    margin: 7px;
    font-size: 18px;
    font-weight: 400;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}
.navsubtitle:hover {
    color: #999;
}
.noborder {
    border: none;
    margin-top: 5px;
    padding-top: 0px;
}
.logout {
    padding-top: 50px;
    cursor: pointer;
}

/* width */
::-webkit-scrollbar {
    width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #ddd;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.signature {
    display: inline-block;
    border: 2px solid;
    border-color: #888;
    background-color: white;
}
.signaturedisable {
    display: inline-block;
    border: 2px solid;
    border-color: #888;
    background-color: #cccccc;
    cursor: no-drop;
}
.sigBot {
    font-family: "BenchNine", sans-serif;
    display: block;
    font-size: 18px;
}
</style>